import { render, staticRenderFns } from "./CreateGrayscaleForm.vue?vue&type=template&id=e4a18a30&scoped=true&"
import script from "./CreateGrayscaleForm.vue?vue&type=script&lang=ts&"
export * from "./CreateGrayscaleForm.vue?vue&type=script&lang=ts&"
import style0 from "./CreateGrayscaleForm.vue?vue&type=style&index=0&id=e4a18a30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4a18a30",
  null
  
)

export default component.exports